import { useRef, useState } from "react";
import { toast } from "sonner";
import { FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/Common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { cn } from "@/lib/utils";

export const useResumeUpload = (onDone, skipJobId) => {
  const { refreshProfile } = useAuth();
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (file.type !== "application/pdf" || file.size > 5 * 1024 * 1024) return toast.error("PDF up to 5MB only");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post("/profile/resume", fd);
      const p = await refreshProfile();
      window.dispatchEvent(new CustomEvent("rpopro:resume-replaced", { detail: { skipJobId } }));
      toast.success("Resume replaced");
      onDone?.(p);
      return true;
    } catch (e) { toast.error(errMsg(e)); return false; } finally { setBusy(false); }
  };
  return { upload, busy };
};

export const InlineResumeUpload = ({ onDone, skipJobId, label = "Upload optimized resume", className, size, variant = "outline", testid = "inline-resume-upload-button" }) => {
  const ref = useRef(null);
  const { upload, busy } = useResumeUpload(onDone, skipJobId);
  return (
    <>
      <input ref={ref} type="file" accept="application/pdf" className="hidden" onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} data-testid={`${testid}-input`} />
      <Button type="button" size={size} variant={variant} onClick={() => ref.current?.click()} disabled={busy} className={cn("h-auto min-h-9 whitespace-normal py-2 text-center", className)} data-testid={testid}>
        {busy ? <Spinner /> : <FileUp className="h-4 w-4" />}{label}
      </Button>
    </>
  );
};
